<script>
    import NormalMask from './NormalMask';
    import NormalInput from './NormalInput';
    // export component
    export default {
        name: 'normal-cascader',
        props: {
            visible: {type: Boolean, default: false},
            withBody: {type: Boolean, default: true},
            border: {type: Boolean, default: true},
            placeholder: {type: String, default: ''},
            disabled: {type: Boolean, default: false},

            actions: {type: Array, default: () => []},
            options: {type: Array, default: () => []},
            selected: {type: Array, default: () => []},

            leftBtn: {type: String, default: '取消'},
            rightBtn: {type: String, default: '确定'},

            separation: {type: String, default: '·'}
        },
        model: {
            prop: 'selected',
            event: 'change'
        },
        watch: {
            visible (nv) {
                this.show = nv;
            },
            actions (nv) {
                this.innerActions = nv;
            },
            currentOptions () {
                const $el = this.$el.querySelector('.with-scroll');
                $el && $el.scrollTo(0, 0);
            },
            selected: {
                handler: function (v) {
                    this.setInnerSelected(v);
                    this.setCurrentOptions(v);
                    this.withBody && (this.showText = this.getShowText());
                },
                deep: true
            },
            options: {
                handler: function (nv) {
                    this.initOptions(nv);
                    this.setInnerSelected();
                    this.setCurrentOptions();
                    this.withBody && (this.showText = this.getShowText());
                },
                immediate: true,
                deep: true
            }
        },
        data () {
            return {
                show: this.visible,
                innerActions: this.actions.length > 0 ? this.actions : [
                    {
                        label: this.leftBtn,
                        onClick: e => {
                            this.handleClose(() => {
                                this.$emit('cancel', e);
                            });
                        }
                    },
                    {
                        label: this.rightBtn,
                        reflectDisabled: true,
                        onClick: () => this.handleChanges()
                    }
                ],
                innerSelected: [],
                innerOptionsMap: {},
                currentOptions: this.options,
                closing: false,
                showText: '',
            };
        },
        methods: {
            handleChanges (cb) {
                this.handleClose(() => {
                    this.withBody && (this.showText = this.getShowText());
                    this.$emit('change', this.innerSelected.map(v => v.value));
                    this.$emit('setText', this.innerSelected.map(v => v.text));
                    cb && cb();
                });
            },
            handleClose (cb) {
                this.closing = true;
                this.$nextTick(() =>
                    setTimeout(() => {
                        console.log('close');
                        this.handleVisible(false);
                        this.closing = false;
                        cb();
                    }, 200)
                );
            },
            renderActions () {
                let elActions = this.innerActions.map((action, i) => {
                    let {label, onClick, reflectDisabled} = action;
                    let cls = this.$util.classNames(
                        'normal-picker__action',
                        {
                            'normal-picker__action__disabled': reflectDisabled && this.isDisabled,
                        }
                    );
                    if (reflectDisabled && this.isDisabled) {
                        onClick = () => {};
                    }
                    return (
                        <a onClick={ onClick.bind(this) } key={ i }
                           class={ cls }>
                            { ' ' }
                            { label }
                        </a>
                    );
                });
                return <div class="normal-picker__hd">{ elActions }</div>;
            },
            renderSelected () {
                const {innerSelected, innerOptionsMap} = this;
                let dom = false;
                if (innerSelected.length) {
                    const limit = innerSelected.length - 1;
                    const child = innerOptionsMap[innerSelected[limit].value].children;
                    dom = child && child.length > 0;
                } else {
                    dom = true;
                }
                dom = dom ? (<div class="normal-picker__item active">请选择</div>) : false;
                return (
                    <div class="normal-picker__options normal-picker__bd-text">
                        { this.innerSelected.map((v) => {
                            return (<div onClick={ () => this.handleSelectedClick(v) }
                                         class="normal-picker__item">{ v.text }</div>);
                        }) }{ dom }
                    </div>
                );
            },
            renderOptions () {
                return (
                    <div class="normal-picker__options with-scroll">
                        {
                            this.currentOptions.map((opt) => {
                                const cls = this.$util.classNames(
                                    'normal-picker__item',
                                    {
                                        'normal-picker__item__active': this.innerSelected.length && this.innerSelected.some(v => v.value === opt.value),
                                    }
                                );
                                return <div class={ cls }
                                            onClick={ () => this.handleItemClick(opt) }>{ opt.text }</div>;
                            })
                        }
                    </div>
                );
            },
            handleSelectedClick (item) {
                const {innerSelected, innerOptionsMap, currentOptions} = this;
                const {level} = item;
                let value = innerSelected[level - 1] ? innerSelected[level - 1].value : null;
                const child = value === null ? this.options : innerOptionsMap[value].children;
                this.currentOptions = child && child.length > 0 ? child : currentOptions;
            },
            handleItemClick (item) {
                const {innerSelected, innerOptionsMap, currentOptions} = this;
                const {value, level} = item;
                innerSelected.splice(level);
                this.$set(innerSelected, level, item);
                const child = innerOptionsMap[value].children;
                this.currentOptions = child && child.length > 0 ? child : currentOptions;
            },
            handleVisible (visible = true) {
                if (this.disabled) return;
                const lastVis = this.show;
                this.show = !!visible;
                if (lastVis !== this.show) {
                    this.$emit('visible', {visible: this.show, instance: this});
                }
            },
            getShowText () {
                return this.innerSelected.map(v => v.text).join(this.separation);
            },
            initOptions (opts = [], level = 0, pid = 0) {
                opts.forEach((v) => {
                    v.pid = pid;
                    v.level = level;
                    this.innerOptionsMap[v.value] = v;
                    if (v.children && v.children.length) {
                        this.initOptions(v.children, level + 1, v.value);
                    }
                });
                return opts;
            },
            setInnerSelected (selected) {
                selected = selected || this.selected || [];
                this.innerSelected = selected.map(v => this.innerOptionsMap[v]);
                const {innerSelected} = this;
                if (innerSelected.length) {
                    this.handleSelectedClick(innerSelected[innerSelected.length - 1]);
                }
            },
            setCurrentOptions (selected) {
                selected = selected || this.selected || [];
                if (!selected || !selected.length) {
                    return this.currentOptions = this.options;
                }
                let lastItem = this.innerOptionsMap[selected[selected.length - 1]];
                if ((!lastItem.children || !lastItem.children.length) && lastItem.pid) {
                    lastItem = this.innerOptionsMap[lastItem.pid];
                }
                this.currentOptions = lastItem.pid ? lastItem.children : this.options;
            }
        },
        computed: {
            isDisabled () {
                let {innerSelected, innerOptionsMap} = this;
                if (!innerSelected || !innerSelected.length) {
                    return true;
                }
                innerSelected = innerSelected[innerSelected.length - 1];
                innerOptionsMap = innerOptionsMap[innerSelected.value];
                return innerOptionsMap && (innerOptionsMap.children && innerOptionsMap.children.length);
            }
        },
        components: {NormalMask, NormalInput},
        mounted () {
        },
        render () {
            const {disabled, show, border, placeholder, closing, showText, withBody} = this;
            const cls = this.$util.classNames(
                'normal-picker',
                {
                    'normal-animate-slide-up': show && !closing,
                    'normal-animate-slide-down': closing
                }
            );
            const maskCls = this.$util.classNames({
                'normal-animate-fade-in': show && !closing,
                'normal-animate-fade-out': closing
            });
            return (
                <div class="normal-cascader">
                    { withBody ? <normal-input nativeOnClick={ this.handleVisible }
                                               disabled={ disabled }
                                               readonly={ true }
                                               border={ border }
                                               value={ showText }
                                               placeholder={ placeholder }/> : false }
                    { show ? (
                        <div>
                            <normal-mask
                                class={ maskCls }
                                nativeOnClick={ e =>
                                    this.handleClose(() => {
                                        this.$emit('cancel', e);
                                    })
                                }
                            />
                            <div class={ cls }>
                                { this.renderActions() }
                                <div class="normal-picker__bd">
                                    { this.renderSelected() }
                                    { this.renderOptions() }
                                </div>
                            </div>
                        </div>
                    ) : false }
                </div>
            );
        }
    };


</script>


<style lang="less" scoped>
    @import "../../assets/less/widgets-var";

    .normal-cascader {
        &:after {
            font-family: cmsicon;
            content: "\e697";
            display: inline-block;
            border-color: @otherIptSelTipsDisbaledClr;
            position: absolute;
            color: @otherIptSelTipsDisbaledClr;
            .px2rem(height, 75);
            .px2rem(line-height, 80);
            .px2rem(width, 60);
            text-align: center;
            top: 50%;
            .px2rem(margin-top, -37.5);
            right: 0;
            background-color: #fff;
            z-index: 9;
        }
    }

    /deep/ .normal-input {
        .px2rem(font-size, 32);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .normal-picker__bd-text {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;

        &.normal-picker__options {
            margin: 10px 0 7px 0;

            .normal-picker__item {
                flex: 1;
                .px2rem(font-size, 28);
                padding-right: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                &:last-child {
                    padding-right: 0;
                }

                &.active {
                    color: @primaryBg;
                }

            }
        }
    }

    .normal-picker__bd {
        display: block;
    }

    .normal-picker__options {
        padding: 0 15px;

        &.with-scroll {
            height: 187px;
            overflow: auto;
        }

        .normal-picker__item {
            text-align: left;
            box-sizing: border-box;
        }
    }
</style>
